var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFlag = function SvgFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M4.75 15.083V4.4c0-.38.216-.727.569-.869.759-.304 2.17-.78 3.574-.78 2.062 0 4.152 2.056 6.214 2.056.945 0 1.893-.216 2.643-.45.708-.22 1.5.29 1.5 1.031v9.075c0 .38-.216.728-.569.87-.759.303-2.17.78-3.574.78-2.062 0-4.152-2.056-6.214-2.056-2.063 0-4.143 1.027-4.143 1.027Zm0 0v6.167"
  })));
};
export default SvgFlag;